export default "__VITE_ASSET__CcpSUMVq__"